module.exports = __webpack_public_path__ + "img/lantern.0e57f8b4.png";